export enum TSAusserordentlicherAnspruchTyp {
    FKJV = 'FKJV',
    ASIV = 'ASIV',
    KEINE = 'KEINE'
}
